module.exports = __webpack_public_path__ + "media/home_button.ce8d546f.mp3";